import { render, staticRenderFns } from "./TransferenciasCVUCBU.vue?vue&type=template&id=ec327ad0&"
import script from "./TransferenciasCVUCBU.vue?vue&type=script&lang=js&"
export * from "./TransferenciasCVUCBU.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciasCVUCBU.vue?vue&type=style&index=0&id=ec327ad0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports